// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IRoute } from '..';
import PackageInstructions from './PackageInstructions';

const routes: IRoute[] = [
    {
        crumbText: 'packaging_instructions',
        component: PackageInstructions,
        exact: true,
        path: '/packageInstructions',
    },
];

export default routes;
